import React from "react";
import { Grid } from "@material-ui/core";
import "date-fns";

import ImpressionsIndicator from "../Impressions/impressions";
import RevenueIndicator from "../Revenue/revenue";
import ViewabilityIndicator from "../Viewability/viewability";
import CPMIndicator from "../CPM/CPM";
import AdunitsIndicator from "../Adunits/adunits";

export default function GeneralIndicators(props) {
  var { publishers, siteId, showAdunits, isDashboard } = props;
  const uniquePublishers = publishers ? publishers.filter((index, value) => publishers.indexOf(index) === value) : publishers;
  return (
    <>
      <Grid container spacing={4}>
        <RevenueIndicator publishers={uniquePublishers} siteId={siteId}></RevenueIndicator>
        <ImpressionsIndicator publishers={uniquePublishers} siteId={siteId} isDashboard={isDashboard}></ImpressionsIndicator>
        <CPMIndicator publishers={uniquePublishers} siteId={siteId}></CPMIndicator>
        <ViewabilityIndicator publishers={uniquePublishers} siteId={siteId}></ViewabilityIndicator>
      </Grid>
      <br/>
      {(showAdunits) ? <AdunitsIndicator publisherId={uniquePublishers} siteId={siteId}></AdunitsIndicator>: <></>}
    </>
  );
}